import { render } from "./SuccessResetPassword.vue?vue&type=template&id=12830ff8&scoped=true"
import script from "./SuccessResetPassword.vue?vue&type=script&lang=js"
export * from "./SuccessResetPassword.vue?vue&type=script&lang=js"

import "./SuccessResetPassword.vue?vue&type=style&index=0&id=12830ff8&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12830ff8"]])

export default __exports__